module.exports = __webpack_public_path__ + "img/securityConfig.acc5cb23.svg";